import { faSignOutAlt, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useAuthz from '../../hooks/useAuthz';
import logoSanef from '../../images/logo.png';
import useMessage from '../../hooks/useMessage';
import useAccountValidation from '../../hooks/useAccountValidation';
import useWindowSize from '../../hooks/useWindowSize';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { logError } from '../Utils/FormatData';
import { MessageContext } from '../../context/MessageContext';

const css = {
  waitingInscriptions: {
    display: 'flex',
    fontFamily: 'Gadugi',
    fontWeight: 'bold',
    fontSize: '12px',
    marginRight: '20px',
    height: '16px',
    padding: '12px',
    flexDirection: 'column',
    alignItems: 'center',
    color: '#bb0060',
    borderRadius: '8px',
    textTransform: 'uppercase',
    boxShadow: '0 2px 6px rgb(0 0 0 / 30%)',
  },
  iconWaitingInscriptions: {
    color: '#bb0060',
    marginRight: '20px',
    height: '25px',
  },
};

const Header = (props) => {
  const reduxConnexion = useSelector(state => state['Connexion']);
  const reduxMessagerie = useSelector(state => state['Messagerie']);
  const reduxAccounts = useSelector(state => state['AccountValidation']);
  const [authz, user, profil] = useAuthz();
  const [width, height] = useWindowSize();
  const nbMessage = useMessage();
  const nbAccounts = useAccountValidation();
  const { unreadRequestPassMessages, unreadPlanificationMessages } = useContext(MessageContext);

  return (
    <div id='topbar'>
      <div id='bloc-logo-template'>
        <Link to='/'>
          <img id='logo-template' alt='' src={logoSanef} />
        </Link>
      </div>
      {authz && (
        <>
          <div id='menu'>
            {
              user.validated === true &&
              <>
                {profil.profil <= 5 && (
                  <>
                    <Link className='lien-menu lien-menu-vert' to='/demande-passage/'>
                      <div className='carre-menu' />
                      <div className='ligne-menu' />
                      <div className='texte-lien-menu'>
                          Dossiers
                          {unreadRequestPassMessages &&
                              <div id='num-message-dossier' className='header' />
                          }
                      </div>
                    </Link>
                    <Link className='lien-menu lien-menu-rose' to='/planification'>
                      <div className='carre-menu' />
                      <div className='ligne-menu' />
                      <div className='texte-lien-menu'>Planification des passages
                       {unreadPlanificationMessages &&
                              <div id='num-message-planification' className='header' />
                          }
                      </div>
                    </Link>
                  </>
                )}
                {profil.profil < 6 && (
                  <Link className='lien-menu lien-menu-orange' to='/facturation'>
                    <div className='carre-menu' />
                    <div className='ligne-menu' />
                    <div className='texte-lien-menu'>Facturation / Devis</div>
                  </Link>
                )}
                {(profil.profil === 1 || profil.profil === 2) && (
                  <Link className='lien-menu lien-menu-bleu' to='/panneau-administration'>
                    <div className='carre-menu' />
                    <div className='ligne-menu' />
                    <div className='texte-lien-menu'>Administration</div>
                  </Link>
                )}
              </>
            }
          </div>

          <div id='bloc-menu-droite'>
            {
              (profil.profil === 1 || profil.profil === 2) && reduxAccounts.accounts > 0 &&
              <>
                {width > 1080 &&
                  <Link to={'/panneau-administration/utilisateur'} className='link-profil' style={css.waitingInscriptions}>
                    <div>Inscription(s) en attente</div>
                  </Link>
                }
                {width <= 1080 && <FontAwesomeIcon icon={faTriangleExclamation} style={css.iconWaitingInscriptions} />}
              </>
            }
            <Link to='/mon-profil' className='link-profil'>
              <div id='bloc-menu-droite-entry'>
                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' style={{ marginRight: '10px', height: '25px' }}>
                  <path
                    d='M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 480c-47.24 0-91.04-14.78-127.2-39.84C132.9 390.9 173.8 352 224 352h64c50.25 0 91.14 38.94 95.21 88.16C347 465.2 303.2 480 256 480zM411.7 416.7C397.6 361.3 347.7 320 288 320H224c-59.73 0-109.6 41.3-123.7 96.72C58.27 375.1 32 319 32 256c0-123.5 100.5-224 224-224s224 100.5 224 224C480 319 453.7 375.1 411.7 416.7zM256 128C211.8 128 176 163.8 176 208C176 252.2 211.8 288 256 288s80-35.82 80-80C336 163.8 300.2 128 256 128zM256 256C229.5 256 208 234.5 208 208S229.5 160 256 160s48 21.53 48 48S282.5 256 256 256z' />
                </svg>
                {
                  width > 1080 &&
                  <>
                    {reduxConnexion.user.prenom && reduxConnexion.user.nom ? reduxConnexion.user.prenom + ' ' + reduxConnexion.user.nom : reduxConnexion.user.raison_sociale}
                  </>
                }
              </div>
            </Link>
            <Link to='/messagerie' className='link-profil' style={{ marginLeft: '15px' }}>
              {
                reduxMessagerie.messages === 0 &&
                <div id='bloc-menu-droite-entry'>
                  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' style={{ marginRight: '10px', height: '25px' }}>
                    <path
                      d='M0 128C0 92.65 28.65 64 64 64H448C483.3 64 512 92.65 512 128V384C512 419.3 483.3 448 448 448H64C28.65 448 0 419.3 0 384V128zM32 128V167.9L227.6 311.3C244.5 323.7 267.5 323.7 284.4 311.3L480 167.9V128C480 110.3 465.7 96 448 96H63.1C46.33 96 31.1 110.3 31.1 128H32zM32 207.6V384C32 401.7 46.33 416 64 416H448C465.7 416 480 401.7 480 384V207.6L303.3 337.1C275.1 357.8 236.9 357.8 208.7 337.1L32 207.6z' />
                  </svg>
                </div>
              }
              {
                reduxMessagerie.messages > 0 &&
                <>
                  <div id='bloc-menu-droite-entry'>
                    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' style={{ marginRight: '10px', height: '25px' }}>
                      <path
                        d='M256 417.1c-16.38 0-32.88-4.1-46.88-15.12L0 250.9v213.1C0 490.5 21.5 512 48 512h416c26.5 0 48-21.5 48-47.1V250.9l-209.1 151.1C288.9 412 272.4 417.1 256 417.1zM493.6 163C484.8 156 476.4 149.5 464 140.1v-44.12c0-26.5-21.5-48-48-48l-77.5 .0016c-3.125-2.25-5.875-4.25-9.125-6.5C312.6 29.13 279.3-.3732 256 .0018C232.8-.3732 199.4 29.13 182.6 41.5c-3.25 2.25-6 4.25-9.125 6.5L96 48c-26.5 0-48 21.5-48 48v44.12C35.63 149.5 27.25 156 18.38 163C6.75 172 0 186 0 200.8v10.62l96 69.37V96h320v184.7l96-69.37V200.8C512 186 505.3 172 493.6 163zM176 255.1h160c8.836 0 16-7.164 16-15.1c0-8.838-7.164-16-16-16h-160c-8.836 0-16 7.162-16 16C160 248.8 167.2 255.1 176 255.1zM176 191.1h160c8.836 0 16-7.164 16-16c0-8.838-7.164-15.1-16-15.1h-160c-8.836 0-16 7.162-16 15.1C160 184.8 167.2 191.1 176 191.1z' />
                    </svg>
                  </div>
                  <div id='num-message' />
                </>
              }
            </Link>

            <div id='boutons-menu-droite'>
              <Link id='btn-deconnexion' to='/deconnexion'>
                Déconnexion
                <span>
                  <FontAwesomeIcon icon={faSignOutAlt} />
                </span>
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Header;
